import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const CircleArrowLeft = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-1.04907e-06 12C-4.69655e-07 18.6278 5.37223 24 12 24C18.6278 24 24 18.6278 24 12C24 9.96215 23.4905 7.99515 22.5331 6.24592C21.7973 4.90263 20.8093 3.7104 19.6263 2.73404C17.4926 0.977406 14.8201 8.02534e-07 12 1.04907e-06C5.37223 1.62849e-06 -1.62849e-06 5.37223 -1.04907e-06 12ZM22.8001 12C22.8001 17.965 17.9651 22.8 12.0001 22.8C6.03507 22.8 1.2001 17.965 1.2001 12C1.2001 6.03497 6.03507 1.2 12.0001 1.2C14.5392 1.2 16.9428 2.07905 18.8631 3.66002C19.9284 4.53921 20.8184 5.61309 21.4807 6.82224C22.3419 8.39575 22.8001 10.1648 22.8001 12Z'
        />
        <path
          d='M9.08981 12L14.3167 6.51222C14.4282 6.39511 14.4283 6.20516 14.3169 6.08796C14.2054 5.97075 14.0246 5.97067 13.9131 6.08778L8.4841 11.7878C8.37249 11.905 8.37249 12.095 8.4841 12.2122L13.9131 17.9122C14.0246 18.0293 14.2054 18.0293 14.3169 17.912C14.4283 17.7948 14.4282 17.6049 14.3167 17.4878L9.08981 12Z'
          stroke='currentColor'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect
            width='24'
            height='24'
            transform='translate(24 24) rotate(180)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
